import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import PropTypes from 'prop-types'
import { path } from 'ramda'
import React from 'react'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import { selectEasymsCategories } from '../../../../../../selectors/hostelworldSelectors/hwEasymsSelector'
import CategoryEditDialog from './CategoryEditDialog'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    }
})

class CategoriesTable extends React.Component {
    state = {
        openId: null
    }

    handleUpdate = organization => {
        this.props.onUpdate(organization)
    }

    handleOpenDialog = openId => {
        this.setState({ openId })
    }

    handleCloseDialog = () => {
        this.setState({ openId: null })
    }

    handleDelete = remoteId => () => {
        const toastrConfirmOptions = {
            onOk: () => this.props.onDelete(remoteId)
        }
        toastr.confirm('Вы уверены, что хотите удалить категорию?', toastrConfirmOptions)
    }

    renderEasymsCategoryCell = id => {
        const category = path(['name'], this.props.easymsCategories[id])
        return category ? (
            <span>
                <em>{category}</em>
                <strong>{' (id: ' + id + ')'}</strong>
            </span>
        ) : null
    }

    render() {
        const { classes, categories = [] } = this.props
        const { openId } = this.state

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID организации</TableCell>
                            <TableCell>Категория EasyMS</TableCell>
                            <TableCell>Категория Hostelworld.com</TableCell>
                            <TableCell>Room Type</TableCell>
                            <TableCell>Occupancy</TableCell>
                            <TableCell padding="checkbox" />
                            <TableCell padding="checkbox" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {categories.map(item => (
                            <TableRow hover key={item.remoteId}>
                                <TableCell>{item.organizationId}</TableCell>
                                <TableCell>{this.renderEasymsCategoryCell(item.ourId)}</TableCell>
                                <TableCell>
                                    <span>
                                        <em>{item.remoteName}</em>
                                        <strong>{' (id: ' + item.remoteId + ')'}</strong>
                                    </span>
                                </TableCell>
                                <TableCell>{item.basicType}</TableCell>
                                <TableCell>{item.beds}</TableCell>
                                <TableCell padding="none">
                                    <CategoryEditDialog
                                        item={item}
                                        open={openId === item.remoteId}
                                        onOpen={this.handleOpenDialog}
                                        onClose={this.handleCloseDialog}
                                        onUpdate={this.handleUpdate}
                                    />
                                </TableCell>
                                <TableCell padding="none">
                                    <IconButton aria-label="Delete" onClick={this.handleDelete(item.remoteId)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}
CategoriesTable.propTypes = {
    classes: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
    onDelete: PropTypes.func.isRequired
}

export default connect(state => ({
    easymsCategories: selectEasymsCategories(state)
}))(withStyles(styles)(CategoriesTable))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/CategoriesTab/CategoriesTable/CategoriesTable.js